// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"c5f993e9","102":"e2826d3d","134":"7a9f694d","261":"36d1c78e","523":"7865cbd7","668":"50f0fe1e","955":"659c8ace","998":"31d6cfe0"}[chunkId] + ".chunk.css";
};